import { CREATE_IMAGE_URL, CREATE_IMAGE_URL_ERR, CREATE_SUBSCRIBER, CREATE_SUBSCRIBER_ERR } from '../../actionTypes/subscriberType'

export default (state, action) => {
  switch (action.type) {

    case CREATE_SUBSCRIBER:
      return {
        ...state,
        createSubscriber: {
          data: action.payload
        }
      }

    case CREATE_SUBSCRIBER_ERR:
      return {
        ...state,
        createSubscriber: { getdata: action.payload }
      }

    case CREATE_IMAGE_URL:
      return {
        ...state,
        createImageUrl: { data: action.payload },
      }
    case CREATE_IMAGE_URL_ERR:
      return {
        ...state,
        createImageUrl: { data: action.payload }
      }

    default:
      return state;
  }
}